// src/apolloClient.js
import { ApolloClient, InMemoryCache } from "@apollo/client/core";


const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const apolloClient = new ApolloClient({
  uri: "/api/v3/query",
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
});

export default apolloClient;
